var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table sheet-balance" }, [
    _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "sheet_total",
              expression: "'sheet_total'"
            }
          ]
        }),
        _vm._v(" "),
        _c("th", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "sheet_balance",
              expression: "'sheet_balance'"
            }
          ]
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.items, function(item) {
        return _c("tr", { key: item.booker.id }, [
          _c(
            "th",
            { staticClass: "text-nowrap", attrs: { title: item.booker.name } },
            [_vm._v(_vm._s(item.booker.name))]
          ),
          _vm._v(" "),
          _c("td", { staticClass: "text-right text-nowrap" }, [
            _vm._v(
              _vm._s(_vm._f("format-currency")(item.balance[0], _vm.currency))
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            {
              staticClass: "text-right text-nowrap",
              class: {
                "number-positive": item.balance[1] > 0,
                "number-negative": item.balance[1] < 0
              }
            },
            [
              _vm._v(
                _vm._s(_vm._f("format-currency")(item.balance[1], _vm.currency))
              )
            ]
          )
        ])
      })
    ),
    _vm._v(" "),
    _c("tfoot", [
      _c("tr", [
        _c("th", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "sheet_total",
              expression: "'sheet_total'"
            }
          ]
        }),
        _vm._v(" "),
        _c("td", { staticClass: "text-right text-nowrap" }, [
          _vm._v(_vm._s(_vm._f("format-currency")(_vm.total, _vm.currency)))
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "text-right text-nowrap" }, [
          _vm._v(
            _vm._s(_vm._f("format-currency")(_vm.totalBalance, _vm.currency))
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50ee5dac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ee5dac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/sheet-balance.vue
// module id = s7At
// module chunks = 3